import { User } from "./user";

export class Ship {
    id?: string;
    name?: string;
    description?: string;
    eni?: string;
    modifiedDate?: Date;
    modifiedUser?: User;
    creationDate?: Date;
    creationUser?: User;
    constructor(ship?: Ship) {
        this.id = ship?.id || "";
        this.name = ship?.name || "";
        this.description = ship?.description || "";
        this.eni = ship?.eni || "";
    }
}
